import React from 'react';
import moment from 'moment';
import bugImage from '../../atoms/icons/usda_bug.png';
import farmersfridge from '../../atoms/icons/farmers_fridge.png';
import styledComponent from '../../utils/styledComponent';

const aldiSkuInfo = [
  {
    sku: 'USDA_CHEF_SALAD_TURKEY',
    gtin: '4069365370988',
    netWeight: {
      oz: '10.05',
      g: '285',
    },
  },

  {
    sku: 'USDA_SANTA_FE_SALAD',
    gtin: '4069365371237',
    netWeight: {
      oz: '10.59',
      g: '300',
    },
  },

  {
    sku: 'USDA_VALUE_CSR_CHIC',
    gtin: '4069365371268',
    netWeight: {
      oz: '7.71',
      g: '219',
    },
  },
];

const StyledDiv = styledComponent('div', {
  border: '1px solid #000',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '9px',
  overflow: 'hidden',
  pageBreakInside: 'avoid',

  '& .header': {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '2px 2px',
    minHeight: '0.35in',
  },
  '& .bugImage': {
    width: '70px',
    height: '70px',
    margin: '0',
  },
  '& .farmersfridge': {
    width: '90px',
    height: '50px',
    margin: '0',
  },
  '& .main': {
    padding: '0',
    textAlign: 'center',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textOverflow: 'ellipsis',
  },
  '& .titlePrettyName': {
    fontSize: '14px',
    fontWeight: 'bold',
    margin: '3px',
    lineHeight: '1.1',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap',
  },
  '& .aldiGtin': {
    fontSize: '10px',
    fontWeight: 'bold',
    marginBottom: '1px',
  },
  '& .netWeightAndLotNumber': {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-evenly',
    marginBottom: '2px',
    lineHeight: '1.5',
  },
  '& .packDate': {
    fontSize: '10px',
    marginBottom: '1px',
    lineHeight: '1.5',
    alignSelf: 'center',
    justifySelf: 'space-around',
  },
  '& .footer': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2px 5px',
    minHeight: '5px',
  },
  '& .keepRefrigerated': {
    fontSize: '13px',
    fontWeight: 'bold',
  },
  '@media print': {
    border: 'none',
  },
});

// Print grid container for 15 slips per page layout (3 columns x 5 rows)
const PrintGridContainer = styledComponent('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 252px)',
  gridTemplateRows: 'repeat(5, 192px)',
  columnGap: '14.4px',
  rowGap: '12px',
  marginTop: '.25in',
  marginBottom: '.25in',
  marginRight: '.125in',
  marginLeft: '.125in',
  border: 'none',
  breakInside: 'avoid',
  pageBreakAfter: 'always',
});

/* eslint-disable react/prop-types */
const AldiPackingSlip = ({ routeStop, items, date, isGrouped = false }) => {
  const { data_ids } = routeStop;

  // Get the first SKU from the packing slip
  const skusInPackingSlip = Object.keys(data_ids).filter((id) => id !== 'Box');

  if (skusInPackingSlip.length === 0) {
    return null; // No SKUs found in packing slip
  }

  const firstSku = skusInPackingSlip[0];

  // Find the corresponding item in items
  const currentItem = items.find((item) => item.id === firstSku);

  if (!currentItem) {
    return null; // Don't render if no item found
  }

  const displayName = currentItem.prettyName || 'N/A';

  // Get production date from the item data or use the route date
  const productionDate = data_ids[firstSku]?.productionDate || date;
  const formattedProductionDate = moment(productionDate).format('MM/DD/YYYY');

  // Calculate best before date (assuming shelf life + 2 days like in RouteStop)
  const shelfLife = currentItem.shelfLife || 0;
  const bestBeforeDate = moment(productionDate).add(shelfLife + 2, 'days');
  const formattedBestBefore = bestBeforeDate.format('MMDDYYYY');

  const gtin = aldiSkuInfo.find((sku) => sku.sku === firstSku)?.gtin || 'N/A';
  const netWeight = aldiSkuInfo.find((sku) => sku.sku === firstSku)
    ?.netWeight || {
    oz: 'N/A',
    g: 'N/A',
  };

  const slipContent = (
    <StyledDiv data-test="aldi-packing-slip">
      <div className="header">
        <img
          src={farmersfridge}
          alt="Farmers Fridge"
          className="farmersfridge"
        />
        <img src={bugImage} alt="USDA Bug" className="bugImage" />
      </div>

      <div className="main">
        <div className="titlePrettyName">{displayName}</div>

        <div className="aldiGtin">{gtin}</div>

        <div className="netWeightAndLotNumber">
          <div className="netWeight">
            {data_ids[firstSku]?.value} / {netWeight.oz}oz Carton
          </div>

          <div className="lotNumber">Lot: {formattedBestBefore}</div>
        </div>

        <div className="packDate">Pack Date: {formattedProductionDate}</div>

        <div className="keepRefrigerated">Keep Refrigerated</div>
      </div>
    </StyledDiv>
  );

  // If this is not part of a group, render with page break
  if (!isGrouped) {
    return <div style={{ pageBreakAfter: 'always' }}>{slipContent}</div>;
  }

  return slipContent;
};

export default AldiPackingSlip;
export { PrintGridContainer };
